import { combineReducers } from 'redux';

import hourlyAlertController from 'modules/LCRMT/Alerts/core/controllers/HourlyAlertsControllers';
import dashboardController from 'modules/LCRMT/Dashboard/core/controllers/DashboardController';
import PlayerController from 'modules/LCRMT/Players/core/controllers/PlayerController';
import alertController from 'modules/LCRMT/Alerts/core/controllers/AlertsController';

import EQUIPMENT_ROUTES from './EquipmentIntegrity/routes';
import DASHBOARD_ROUTES from './Dashboard/routes';
import PLAYERS_ROUTES from './Players/routes';
import REPORTS_ROUTES from './Reports/routes';
import ALERTS_ROUTES from './Alerts/routes';
import SETTINGS_ROUTES from './Settings/routes';

import dashboard from './Dashboard/store/reducers';
import player from './Players/store/reducers';
import alerts from './Alerts/store/reducers';

const getProjectState = (state) => state.LCRMT;

const routes = [
  ...ALERTS_ROUTES,
  ...DASHBOARD_ROUTES,
  ...PLAYERS_ROUTES,
  ...EQUIPMENT_ROUTES,
  ...REPORTS_ROUTES,
  ...SETTINGS_ROUTES
];

const controllers = [
  hourlyAlertController(),
  alertController(),
  PlayerController(),
  dashboardController()
];

const reducers = combineReducers({
  ...dashboard,
  ...alerts,
  ...player
});

export {
  getProjectState,
  controllers,
  reducers,
  routes
};
